export default {
  user: {
    register: '/merchants/registers/create',
    sendVerifiCode: '/merchants/registers/verify',
    login: '/login',
    logout: '/logout',
    getCodeImgKey: '/image-codes/retrieve',
    getCodeImg: '/image-codes/create',
    verifyCodeImg: '/image-codes/verify',
    // retrieve: '/users/retrieve'
    telRepeat: '/merchants/registers/retrieve'
  },
  securitySetting: {
    changeMobile: '/security_settings/merchants/mobiles/update',
    modifyPassword: '/security_settings/passwords/update',
    forgotPassword: '/security_settings/passwords/reset',
    loginForgotPassword: '/security_settings/merchants/passwords/reset',
    modifyPayPassword: '/security_settings/pay_passwords/update',
    setPayPassword: '/security_settings/pay_passwords/create',
    bindEmail: '/security_settings/merchants/emails/enabled',
    unbindEmail: '/security_settings/merchants/emails/disabled',
    sendEmailCode: '/emails/send',
    verifyEmailCode: '/emails/verify',
    enabled: '/security_settings/merchants/phone/enabled',//绑定
    disabled: '/security_settings/merchants/phone/disabled ',//解绑
  },
  common: {
    fileUpload: '/files/upload',
    queryFile: '/files/search',
    all_constants: '/constants/retrieveAll',
    all_system_constants: '/system_settings/retrieveAll',
    all_banks: '/banks/retrieveAll', //获取所有银行
    dictSearch: '/dicts/searchByPage',
    allCurrency: '/currencies/retrieveAll',
    allCountry: '/countries/retrieveAll'
  },
  merchant: {
    add: '/merchants/create',
    retrieve: '/merchants/retrieve',
    queryById: '/merchants/merchant_integration/retrieve',
    findMerchantBaseInfo: '/merchants/base_infos/retrieve',
    findByMerchantNumber: '/merchants/retrieveByMerchantNumber',
    downLoadAgreement: '/merchants/agreements/download',
    uploadAgreement: '/merchants/agreements/upload',
    updateMerchantIntegrateStep: '/merchants/operation/status/update',
    findProductById: '/merchants/products/manager/retrieve', //查询商户产品
    getfindByCustomerManagerCode: 'user/findByCustomerManagerCode', //获取客户经理
    newQueryCity: '/pub_areas/manager/retrieveAll',//(新获取地区): '/pub_areas/manager/retrieveAll',//(新获取地区)
    reconciliationList: '/merchant/account_check/query',//普通商户对账列表
    exportReconciliation: '/merchant/account_check/save',//普通商户对账文件下载
  },
  easypay: {
    basicenterprise: '/api/mp_system/enterprises/verify',
    ocranduploadfile: '/api/mp_system/ocrs/verifyAndUpload',
    verifyBank: '/api/mp_system/banks/verify',
    crabinSearch: '/cardbin/search',
    verifyMsgCode: '/api/mp_system/banks/verifyWithMsgCode',
  },
  wallet: {
    createWithdraw: '/transactions/withdraws/create',
    createDeposit: '/transactions/deposits/create',
    multiAccount: '/m_accounts/details/retrieveAll',
    transactionDetailSearch: '/m_accounts/details/retrieve',
    transactionDetailDownload: '/m_accounts/details/download',
    crossAccountInfo: '/m_accounts/cross_border/retrieve',
    domesticAccountInfo: '/m_accounts/domestic/retrieve',
    uploadVoucher: '/transactions/deposits/voucher/upload',
    accountRetrieve: '/merchants/banks/accounts/retrieve',
    banks: '/gateway_payments/banks/retrieveAll',
    //海外
    domesticReceivable: '/overseas/account/front/domesticReceivable',//商户境内收款
    overseasAccountAdd: '/overseas/account/front/createOrUpdate',//新增商户境内修改
    overseasAccountList: '/overseas/account/front/searchByPage',//海外收款账号分页搜索
    overseasAccountItem: '/overseas/account/front/retrieve',//海外收款单例
    fillUploadBc: '/overseas/account/front/fillUpload',//补传资料
    currencyOfCountryList: '/overseas/account/front/currencyOfCountry',//币种列表
    orderTemplate: '/overseas/trans/front/orderTemplate',//下载模板
    downFillFile: '/overseas/account/manager/downFillFile',//补传下载
    //钱包
    walletByMerchant: '/overseas/wallet/front/walletByMerchant',//查询商户对应的账户
    overseasWalletList: '/overseas/wallet/front/searchByPage',//海外钱包流水分页搜索
    findAccAmount: '/overseas/wallet/front/findAccAmount',//获取余额
    findAllAcc: '/overseas/account/front/findAllAcc',//查询商户对应的账户
    findAccDetail: '/overseas/account/front/findAccDetail',//查询商户对应的账户详情
    channelCountry: '/overseas/account/front/channelCountry',//查询收款账户国家
    balancereminderCreate:'/m_accounts/balancereminder/create',//余额提醒创建
    balancereminderItem:'/m_accounts/balancereminder/retrieve',//余额提醒
    offRemind:'/m_accounts/balancereminder/disabled',//关闭余额提醒
    updateRemind:'/m_accounts/balancereminder/update',//关闭余额提醒
    enabled:'/m_accounts/balancereminder/enabled',//开启余额提醒
    overseasAccList:'/curAccounts/merchant/list',//境外账户列表
    overseasAccRetrieve:'/curAccounts/merchant/retrieve',//境外账户列表明细
    accountDetail:'/curAccounts/merchant/accountDetail',//境外账户列表余额明细

    bankInfo:'/oversea/deposit/merchant/bankInfo',//获取帐户信息
    create:'/oversea/deposit/merchant/create',//充值
    at_recharge:'/fast/transfer/merchant/at_recharge',//闪充支付宝微信
    kj_recharge:'/fast/transfer/merchant/recharge',//闪充快捷
    queryDepositChannelType:'/fast/transfer/merchant/queryDepositChannelType',//闪充快捷
    payTransRetrieveById:'/transaction_manager/flash_charge/payTransRetrieveById',//查询是否支付
    getB2bTransferInfo:'/fast/transfer/merchant/getB2bTransferInfo',//企业网银充值金额计算
  },
  transaction: {
    gatewaySearch: '/transactions/gateway_payments/searchByPage',
    gatewayDownload: '/transactions/gateway_payments/download',
    gatewayQuery: '/transactions/gateway_payments/retrieve',
    authenticationSearch: '/transactions/authes/searchByPage',
    authenticationQuery: '/transactions/authes/retrieve',
    authenticationDownload: '/transactions/authes/download',
    scanPayDownload: '/transactions/scan_payments/download',
    scanPayQuery: '/transactions/scan_payments/retrieve',
    scanPaySearch: '/transactions/scan_payments/searchByPage',
    scanPayRefund: '/transactions/refund/create',
    refundDownload: '/transactions/refund/download',
    refundQuery: '/transactions/refund/retrieve',
    refundSearch: '/transactions/refund/searchByPage',
    fastPaymentDownload: '/transactions/fast_payments/download',
    fastPaymentQuery: '/transactions/fast_payments/retrieve',
    fastPaymentSearch: '/transactions/fast_payments/searchByPage',
    onBehalfDownload: '/transactions/on_behalf_payments/download',
    onBehalfQuery: '/transactions/on_behalf_payments/retrieve',
    onBehalfSearch: '/transactions/on_behalf_payments/single/searchByPage',
    withdrawSearch: '/transactions/withdraws/searchByPage',
    withdrawDownload: '/transactions/withdraws/download',
    specialFastSearch: '/transactions/discounts/searchByPage',
    specialFastDownload: '/transactions/discounts/download',
    depositsSearch: '/transactions/deposits/searchByPage',
    depositsDownload: '/transactions/deposits/download',
    commitCustomSearch: '/transactions/commit_custom/searchByPage',
    commitCustomDownload: '/transactions/commit_custom/download',
    overseaList: '/oversea/deposit/merchant/searchByPage',//境外充值列表
    overseaExport: '/oversea/deposit/merchant/export',//境外充值列表导出
    getAccountValue: '/oversea/deposit/merchant/getAccountValue',//境外充值列表查询账户
  },
  fee: {
    feeSearch: '/transaction/fee/month/searchByPage',
    feeDownload: '/transaction/fee/month/download',
    feeConfirm: '/transaction/fee/month/update',
    detailSearch: '/transactions/fees/details/searchByPage',
    detailRetrieve: '/transactions/fees/details/retrieve',
    detailDownload: '/transactions/fees/details/download'
  },
  purchase: {
    createOrder: '/transactions/purchase_payments/manager/create',
    payOrder: '/transactions/purchase_payments/paids/manager/create',
    querySumAmount: '/transactions/purchase_payments/amounts/manager/calculate',
    orderDetailsDownload: '/transactions/purchase_payments/orders/details/manager/download',
    getOrderTemplateUrl: '/transactions/purchase_payments/orders/template/manager/retrieve',
    progressQuery: '/transactions/purchase_payments/progress/manager/retrieve', //进度查询
    transactionList: '/transactions/purchase_payments/manager/searchByPage',
    transactionDownload: '/transactions/purchase_payments/manager/download',
    // getOverseasTemplateUrl: '/transactions/purchase_payments/overseas/template/manager/retrieve', // 收款人信息模板
    getOverseasTemplateUrl: '/transactions/purchase_payments/issue/template/manager/downloadCountry', // 收款人信息模板
    uploadPayeeMaterial: '/transactions/purchase_payments/paid/documents/manager/upload', // 上传收款人资料
    uploadOrderDetail: '/transactions/purchase_payments/orders/manager/upload', // 上传订单明细
    uploadMaterial: '/transactions/purchase_payments/documents/manager/upload', // 上传影像资料
    orderList: '/transactions/purchase_payments/orders/manager/searchByPage', // 订单明细列表
    detail: '/transactions/purchase_payments/batch/details/manager/retrieve',
    checkInfo: '/transactions/purchase_payments/manager/checkInfo',//是否黑名单
    revoke: '/transactions/purchase_payments/manager/cancel',
    electReceiptDownload: '/transactions/purchase_payments/receiptions/download',
    queryCountry: '/transactions/purchase_payments/paids/manager/retrieveAll',
    queryCurrency: '/transactions/purchase_payments/paids/manager/retrieve',
    retrieveExpries: '/transactions/purchase_payments/expires/manager/retrieve', //到账时间
    parsePayeeInfoFile: '/transactions/purchase_payments/issued_orders/parsePayeeInfoFile', //解析收款人模板
    fileUpload: '/transactions/purchase_payments/issued_orders/upload',//上传收款人模板
  },
  receiving: { //收结汇
    receiptAll: '/transactions/receipts/searchByPage',
    receiptExport: '/transactions/receipts/download',
    receiptCreate: '/transactions/receipts/create',
    receiptOrderAll: '/transactions/receipt/orders/searchByPage',
    exportLackOrder: '/transactions/receipt/detail_without_orders/download',
    exportBadOrder: '/transactions/receipt/orders/errors/download',
    // uploadOrder: '/transactions/receipt/orders/upload',原上传
    uploadOrder: '/transactions/receipt/orders/batch/upload',

    exportBadDistribute: '/transactions/receipt_distribute_batches/errors/download',
    orderExport: '/transactions/receipt/orders/download',
    uploadMaterial: '/transactions/receipts/document/upload',
    //订单
    orderBatchList: '/transactions/receipt/orders/batch/searchByPage',
    batchDownload: '/transactions/receipt/orders/batch/download',
    missing: '/transactions/receipt/detail_without_orders/retrieve',
    fileDownload: '/transactions/receipt/orders/batch/fileDownload',//收结汇订单库下载
    // 结汇下发start
    distributeAll: '/transactions/receipt_distribute_batches/searchByPage',
    distributeExport: '/transactions/receipt_distribute_batches/download',
    distributeDetailAll: '/transactions/receipt_distributes/details/searchByPage',
    distributeDetailExport: '/transactions/receipt_distributes/details/download',
    saveDistribute: '/transactions/receipt_distributes/details/upload',
    createDistribute: '/transactions/receipt_distribute_batches/create',
    getSupplyModel: '/transactions/receipt_distribute_batches/getSupplyModel',//结汇下发模板下载
    // 结汇下发end
    issued: '/transactions/receipt_distributes/details/searchByPage',
    exportIssued: '/transactions/receipt_distributes/details/download',
    //上传订单
    setUploadOrder: '/transactions/receipt/orders/batch/relate/upload',
    setDownloadOrder: '/transactions/receipt/detail_without_orders/batch/export',
    recordList: '/merchants/busReports/merPage', //汇款人备案列表
    addRecord: '/merchants/busReports/merAdd', //新增汇款人备案
    getAccountName: '/curAccounts/merchant/accountByPage', //发起收结汇新增查询
  },

  //海外收款
  overseasCollection:{
    receiptAll: '/overseas/trans/front/searchByPage',
    setCreate: '/overseas/trans/front/create',
  },

  behalf: {
    batchCreate: '/transactions/on_behalf_payments/batch/create',
    batchSearch: '/transactions/on_behalf_payments/batch/search',
    calculateAmount: '/transactions/on_behalf_payments/calculate',
    detailExport: '/transactions/on_behalf_payments/download',
    singleSearch: '/transactions/on_behalf_payments/single/searchByPage',
    verify: '/transactions/on_behalf_payments/verify'
  },
  bankRecord: {
   search: '/merchants/bank_reports/searchByPage',//机构商户备案查询
   downloadReport: '/merchants/bank_reports/download',
   saveReport: '/merchants/bank_reports/upload',
   downloadTemplate: '/merchants/bank_reports/details/download',
   uploadReportMaterial: '/merchants/bank_reports/details/upload',
   selfSearch: '/merchants/bank_reports/details/search', //自营商户备案查询
  },
  virtual:{
    list:'/transactions/virtual/searchByPage',//虚拟卡list
    lock:'/transactions/virtual/rate/lock',//锁定报价
    create:'/transactions/virtual/create',//开卡
    vanHistory:'/transactions/virtual/van/history/searchByPage',//卡详情
    uploadMaterial:'/transactions/virtual/uploadMaterial',//上传
    reUploadMaterial:'/transactions/virtual/reUploadMaterial',//补传
    isCreate:'/transactions/virtual/isCreated',//是否有虚拟卡
    materialDownload:'/transactions/virtual/downloadMaterial',//下载资料
    denominationlist:'/transactions/virtual/base/trans/searchByPage',//虚拟卡list
    exportDenomination:'/transactions/virtual/base/trans/download',//下载资料
    recharge:'/transactions/virtual/deposit/create',//充值
    refundApply:'/transactions/virtual/refundApply',//退款
    virtualDskList: '/transactions/virtual/pp/searchByPage',//电商卡列表
    virtualDskSkMb: '/transactions/virtual/pp/downloadCreate',//电商卡申卡模板
    virtualDskCzMb: '/transactions/virtual/pp/downloadRecharge',//电商卡充值模板
    virtualDskCreate: '/transactions/virtual/pp/create',//电商卡申卡模板
    virtualDskDownload: '/transactions/virtual/pp/download',//电商卡申卡导出
    virtualDCzRecharge: '/transactions/virtual/pp/recharge',//电商卡充值提交
    virtualRetrieve: '/transactions/virtual/pp/retrieve',//电商卡单例
    isMultiExist: '/van/currency/detail/exist',//是否有多币种虚拟卡
    getCardProductList: '/van/currency/transaction/queryProduct',//查询多币种虚拟卡产品
    batchMultiCreate: '/van/currency/transaction/batchCreate',//批量创建多币种虚拟卡
    batchCreateCardList: '/van/currency/transaction/batchCreateSearchByPage',//查询批量生卡列表
    multiList: '/van/currency/detail/searchByPage',//查询多币种数字卡列表
    exportMultiList: '/van/currency/detail/download',//多币种列表下载
    multiCardInfo: '/van/currency/detail/retrieve',//多币种数字卡详情
    getSecurityCode: 'van/currency/detail/getSecurityCode',//多币种数字卡获取安全码
    multiDenominationList: '/van/currency/transaction/searchByPage',//查询多币种卡面额列表
    multiBillingList: '/van/currency/billing/searchByPage',//多币种数字卡交易列表
    getElements: '/van/currency/detail/getElements',//多币种数字卡获取卡要素
    vanCancel: '/van/currency/transaction/vanCancel',//关卡
  },
  agent: {
    search: '/agents/merchant/searchByPage',//代理商下级商户列表查询
    subMerchantCount: '/agents/merchant/querySubMerchantCount',//代理商拓展商户数
    fastPaymentSearch: '/agents/transactions/fast_payments/searchByPage',//快捷支付交易查询
    fastPaymentDownload: '/agents/transactions/fast_payments/download',//快捷支付导出
    gatewaySearch: '/agents/transactions/gateway_payments/searchByPage',//网关支付查询
    gatewayDownload: '/agents/transactions/gateway_payments/download',//网关支付导出
    authenticationSearch: '/agents/transactions/authes/searchByPage',//鉴权交易查询
    authenticationDownload: '/agents/transactions/authes/download',//鉴权导出
    onBehalfSearch: '/agents/transactions/on_behalf_payments/searchByPage',//代付交易查询
    onBehalfDownload: '/agents/transactions/on_behalf_payments/download',//代付交易导出
    scanPaySearch: '/agents/transactions/scan_payments/searchByPage',//扫码支付交易查询
    scanPayDownload: '/agents/transactions/scan_payments/download',//扫码支付导出
    refundSearch: '/agents/transactions/refunds/searchByPage',//退款查询
    refundDownload: '/agents/transactions/refunds/download',//退款导出
    commitCustomSearch: '/agents/transactions/commit_custom/searchByPage',//海关推送查询
    commitCustomDownload: '/agents/transactions/commit_custom/download',//海关推送导出
    specialFastSearch: '/agents/transactions/discounts/searchByPage',//订单推送查询
    specialFastDownload: '/agents/transactions/discounts/download',//订单推送导出
    transactionList: '/agents/transactions/purchasePayments/searchByPage',//购付汇列表查询
    transactionDownload: '/agents/transactions/purchasePayments/download',//购付汇列表导出
    receiptAll: '/agents/transactions/receipts/searchByPage',//收结汇列表查询
    receiptExport: '/agents/transactions/receipts/download',//收结汇列表导出
    distributeAll: '/agents/transactions/receipt_distribute_batches/searchByPage',//结汇下发列表查询
    distributeExport: '/agents/transactions/receipt_distribute_batches/download',//结汇下发列表导出
    exportReconciliation: '/agents/sub_merchant/account_check/save',//代理商对账
    reconciliationList: '/agents/sub_merchant/account_check/query',//代理商对账列表
    overseasReceiptAll: '/agents/overseas/trans/searchByPage',//海外收款列表查询
    vaAccountExport: '/agents/transactions/virtual/download',//下载
    vaAccountList: '/agents/transactions/virtual/searchByPage',//虚拟卡列表查询
    vanHistory:'/agents/transactions/virtual/van/history/searchByPage',//卡详情
    materialDownload:'/agents/transactions/virtual/downloadMaterial',//下载资料
    denominationlist:'/agents/transactions/virtual/base/searchByPage',//虚拟卡list
    exportDenomination:'/agents/transactions/virtual/base/download',//下载资料
  },
  fileDownload:{
    feeDetailExport:'/trans/fee/merExport',  //手续费报表
    feeMonthExport:'/trans/fee/month/merExport',  //手续费月报
    merAccount:'/maccount/merchant/export',  //后端-账户详细导出
    exportMultiDenominationList: '/trans/van/currency/export',//多币种列表下载
    withoutOrders: '/receipt/withoutOrders/export',//缺失订单下载
    receiptTrans: '/receipt/receiptTrans/export',//收结汇列表
    merDistributes: '/receipt/merDistributes/export',//结汇下发详情列表
    merDistributesBatch: '/receipt/merDistributeBatches/export',//结汇下发列表
  },
  overseasReceipt:{
    fcasettlebatch:'/collect/fcasettlebatch/merchant/searchByPage',//结算明细列表
    orderDetails:'/overseas/acquiring/merchant/searchByPage',//订单明细
    orderDetailsRetrieve:'/overseas/acquiring/merchant/retrieve',//订单明细详情
    refundList:'/overseas/acquiring/refund/merchant/searchByPage',//退款明细
    refund:'/overseas/acquiring/merchant/refund',//发起退款
    dispute:'/overseas/acquiring/dispute/merchant/searchByPage',//争议订单
    caseReplay:'/overseas/acquiring/dispute/merchant/caseReplay',//案件回复
  }
}
